import makeUrl from '@/utils/makeUrl';
const shopApiPre = `/api/store`;
const shopApiList = [
	// 门店列表
	'storeList',
	// 门店详情
	'storeDetail',
	// 门店配送时间
	'getSendTime',
	// 餐品加入购物车
	'addMeal',
	// 餐品评价列表
	'commentList',
	// 餐品详情
	'mealDetail',
	// 确认购物车
	'verifyCart',
	// 扫码点餐
    'desk',
    // 必选品
    'verifyAnchor',
];
const shopApi = {};

shopApiList.forEach(key => {
	shopApi[`${key}Url`] = makeUrl(shopApiPre, key);
});
export default shopApi;